<!-- Payment Form Dialog -->
<mat-dialog-content style="height: 100%; display: flex; flex-direction: column">
  <mat-card>
    <mat-card-content>
      <form [formGroup]="invoiceForm" (ngSubmit)="submitInvoiceDetails()">
        <h5
          style="
            color: rgba(0, 0, 0, 0.8);
            font-weight: 500;
            padding-bottom: 0.5rem;
            text-align: center;
          "
        >
          Billing Address
        </h5>

        <!-- Country Dropdown -->
        <div>
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Country</mat-label>
            <mat-select formControlName="country" required>
              <mat-option
                *ngFor="let country of countries"
                [value]="country.value"
              >
                {{ country.label }}
              </mat-option>
            </mat-select>
            <mat-error>Country is required</mat-error>
          </mat-form-field>
        </div>

        <!-- GST Registration Radio -->
        <div style="margin-bottom: 20px" *ngIf="!isInternationalPayment">
          <label style="font-weight: 500; display: block; margin-bottom: 8px">
            Registered for GST?
          </label>
          <mat-radio-group
            formControlName="hasGST"
            aria-label="Registered for GST?"
            style="display: flex; gap: 20px"
            color="accent"
          >
            <mat-radio-button color="primary" [value]="true"
              >Yes</mat-radio-button
            >
            <mat-radio-button color="primary" [value]="false"
              >No</mat-radio-button
            >
          </mat-radio-group>
        </div>

        <!-- GST Number Field (Conditional) -->
        <div
          *ngIf="invoiceForm.get('hasGST')?.value && !isInternationalPayment"
        >
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>GST Number</mat-label>
            <input
              matInput
              formControlName="gstNumber"
              placeholder="22AAAAA0000A1Z5"
            />
            <mat-hint>Format: 22AAAAA0000A1Z5</mat-hint>
            <mat-error
              *ngIf="invoiceForm.get('gstNumber')?.hasError('pattern')"
            >
              Invalid GST format
            </mat-error>
          </mat-form-field>
        </div>

        <div>
          <!-- State Dropdown -->
          <div *ngIf="!isInternationalPayment">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>State</mat-label>
              <mat-select
                formControlName="state"
                [required]="!isInternationalPayment"
                (selectionChange)="loadCities()"
              >
                <mat-option *ngFor="let state of states" [value]="state.state">
                  {{ state.state }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="!isInternationalPayment"
                >State is required</mat-error
              >
            </mat-form-field>
          </div>

          <!-- district Dropdown -->
          <div *ngIf="!isInternationalPayment">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>District</mat-label>
              <mat-select
                formControlName="district"
                [required]="!isInternationalPayment"
                [disabled]="!invoiceForm.get('state')?.value"
              >
                <mat-option *ngFor="let distric of district" [value]="distric">
                  {{ distric }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="!isInternationalPayment"
                >District is required</mat-error
              >
            </mat-form-field>
          </div>

          <!-- Address Line -->
          <div>
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Address Line</mat-label>
              <textarea
                matInput
                formControlName="addressLine"
                rows="2"
                required
              ></textarea>
              <mat-error>Address is required</mat-error>
            </mat-form-field>
          </div>

          <!-- pinCode -->
          <div style="margin-bottom: 5px">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Pincode</mat-label>
              <input
                matInput
                formControlName="pinCode"
                [required]="!isInternationalPayment"
                type="number"
                maxlength="6"
                minlength="6"
              />
              <mat-error *ngIf="!isInternationalPayment"
                >Valid 6-digit pincode required</mat-error
              >
            </mat-form-field>
          </div>
        </div>

        <!-- Company Name -->
        <div>
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Gym Name (Optional)</mat-label>
            <input matInput formControlName="gymName" />
          </mat-form-field>
        </div>
      </form>
    </mat-card-content>

    <mat-card-actions style="display: flex; justify-content: space-around">
      <button mat-button mat-dialog-close>Cancel</button>
      <button
        mat-raised-button
        color="primary"
        (click)="submitInvoiceDetails()"
      >
        Pay
      </button>
    </mat-card-actions>
  </mat-card>
</mat-dialog-content>
